'use strict';

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Evolutionary = require('evolutionary');
var makeGenerator = require('evolutionary/generator');
var Chance = require('chance');

var invoker = require('ramda/src/invoker');
var pipe = require('ramda/src/pipe');
var split = require('ramda/src/split');
var uniq = require('ramda/src/uniq');
var sortBy = require('ramda/src/sortBy');
var join = require('ramda/src/join');

var chance = new Chance();

var charCode = invoker(1, 'charCodeAt')(0);

var getCharset = pipe(split(''), uniq, sortBy(charCode), join(''));

var randIndex = function randIndex(str) {
  return chance.integer({ min: 0, max: str.length - 1 });
};

var plusOrMinus1 = function plusOrMinus1() {
  return chance.bool() ? 1 : -1;
};

var wrapLength = function wrapLength(len, n) {
  return (n + len) % len;
};

var replaceCh = function replaceCh(str, index, ch) {
  return str.substr(str, index) + ch + str.substr(index + 1);
};

module.exports = _regenerator2.default.mark(function _callee(solution, overrideCharset) {
  var charset, charsetLength, charIndex, mutateCh, mutate, seed, crossover, fitness, evolve, generator, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, pop;

  return _regenerator2.default.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          charset = getCharset(overrideCharset || solution);
          charsetLength = charset.length;
          charIndex = charset.split('').reduce(function (obj, ch, i) {
            obj[ch] = i;
            return obj;
          }, {});

          mutateCh = function mutateCh(ch) {
            return charset[wrapLength(charsetLength, charIndex[ch] + plusOrMinus1())];
          };

          mutate = function mutate(str) {
            var index = randIndex(str);
            return replaceCh(str, index, mutateCh(str[index]));
          };

          seed = function seed() {
            return chance.string({
              length: solution.length,
              pool: charset
            });
          };

          crossover = function crossover(mother, father) {
            var ca = randIndex(mother);
            var cb = randIndex(mother);
            var temp = void 0;

            if (ca > cb) {
              temp = ca;
              ca = cb;
              cb = temp;
            }

            var son = father.substr(0, ca) + mother.substr(ca, cb - ca) + father.substr(cb);
            var daughter = mother.substr(0, ca) + father.substr(ca, cb - ca) + mother.substr(cb);
            return [son, daughter];
          };

          fitness = function fitness(str) {
            var fitness = 0;

            for (var i = 0; i < str.length; i++) {
              if (str[i] === solution[i]) {
                fitness += 1;
              }
              fitness += (charsetLength - Math.abs(str.charCodeAt(i) - solution.charCodeAt(i))) / charsetLength;
            }

            return fitness;
          };

          evolve = Evolutionary({ seed: seed, fitness: fitness, mutate: mutate, crossover: crossover });
          generator = makeGenerator(evolve, function (pop) {
            return pop[0] === solution;
          });
          _iteratorNormalCompletion = true;
          _didIteratorError = false;
          _iteratorError = undefined;
          _context.prev = 13;
          _iterator = (0, _getIterator3.default)(generator);

        case 15:
          if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
            _context.next = 22;
            break;
          }

          pop = _step.value;
          _context.next = 19;
          return pop[0];

        case 19:
          _iteratorNormalCompletion = true;
          _context.next = 15;
          break;

        case 22:
          _context.next = 28;
          break;

        case 24:
          _context.prev = 24;
          _context.t0 = _context['catch'](13);
          _didIteratorError = true;
          _iteratorError = _context.t0;

        case 28:
          _context.prev = 28;
          _context.prev = 29;

          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }

        case 31:
          _context.prev = 31;

          if (!_didIteratorError) {
            _context.next = 34;
            break;
          }

          throw _iteratorError;

        case 34:
          return _context.finish(31);

        case 35:
          return _context.finish(28);

        case 36:
        case 'end':
          return _context.stop();
      }
    }
  }, _callee, this, [[13, 24, 28, 36], [29,, 31, 35]]);
});


/*****************
 ** WEBPACK FOOTER
 ** ./~/genetic-phrase-solver/lib/index.js
 ** module id = 242
 ** module chunks = 0
 **/